module.exports = __webpack_public_path__ + "assets/img/site-01.2d4e3347.jpg";